/*! @azure/msal-common v15.13.3 2025-12-04 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-common";
const version = "15.13.3";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
